// extracted by mini-css-extract-plugin
export default {"comments":"ProductComments_comments__aZkTl","comments__top":"ProductComments_comments__top__Y6WEN","comments__btn":"ProductComments_comments__btn__AlEFP"};